// extracted by mini-css-extract-plugin
export default {"wrap":"SentTransaction_wrap__vzeti","row":"SentTransaction_row__CPqLp","column":"SentTransaction_column__Oh6GF"};